import React from 'react';
import { Badge } from '../../ui';

/**
 * EstadoBadge
 *
 * Badge del estado de un activo, con la variante del DS v2 acorde:
 *   disponible  → success  (verde)
 *   asignado    → info     (azul)
 *   reparacion  → warning  (ámbar)
 *   baja        → secondary(gris suave)  + texto tachado conceptual
 *
 * Variantes del DS v2 (INSTRUCCIONES): success warning danger info
 * secondary purple.
 */

const MAP = {
  disponible: { variant: 'success', label: 'Disponible' },
  asignado: { variant: 'info', label: 'Asignado' },
  reparacion: { variant: 'warning', label: 'En reparación' },
  baja: { variant: 'secondary', label: 'De baja' },
};

export default function EstadoBadge({ estado }) {
  const cfg = MAP[estado] || { variant: 'secondary', label: estado || '—' };
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}
